import { render } from "./NonCriticalSteps.vue?vue&type=template&id=0cb07ec0&scoped=true"
import script from "./NonCriticalSteps.vue?vue&type=script&lang=js"
export * from "./NonCriticalSteps.vue?vue&type=script&lang=js"

import "./NonCriticalSteps.vue?vue&type=style&index=0&id=0cb07ec0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb07ec0"]])

export default __exports__